// Listen for the pplrAddToCartCompleted custom event
window.addEventListener("pplrAddToCartCompleted", function (e) {
    const cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

    fetch("/?sections=cart-drawer,cart-icon-bubble")
        .then((response) => response.json())
        .then((sections) => {
            cart.renderContents({ sections });
        })
        .catch((e) => {
            console.error(e);
        })
        .finally(() => {
            if (cart.classList.contains("is-empty")) {
                cart.classList.remove("is-empty");
            }
        });
});

